


















































































import Vue from 'vue'
import Component from 'vue-class-component'
import Card from '@/components/Card.vue'
import ScrollView from '@/components/ScrollView.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { TodoModule } from '@/store/modules/todo.module'
import { getModule } from 'vuex-module-decorators'
import NoRows from '@/components/tables/NoRows.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import Icon from '@/components/Icon.vue'
import { EViewedUpdate, ITodoLineItem } from '@zunta/configurations'
import HolidayPopup from '../components/HolidayPopup.vue'

@Component({
  components: { Icon, NoRows, LoaderWrapper, ScrollView, Card, HolidayPopup }
})
export default class ToDo extends Vue {
  EViewedUpdate = EViewedUpdate
  todoModuleInstance: TodoModule = getModule(TodoModule, this.$store)
  user: User = Api.getUser() as User
  isLoading: boolean = false
  get todos () {
    return this.todoModuleInstance.todos
  }

  async mounted () {
    try {
      this.isLoading = true
      await this.todoModuleInstance.getTodoList({})
    } finally {
      this.isLoading = false
      this.setShowTooltips()
      window.addEventListener('resize', this.setShowTooltips)
    }
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.setShowTooltips)
  }

  setShowTooltips () {
    const isEllipsisActive = (e: any) => (e.offsetWidth < e.scrollWidth)
    this.$nextTick(() => {
      const items: NodeListOf<Element> = document.querySelectorAll('body .todo-list .todo-item .description')

      if (!items || !items.length) {
        return
      }

      const todos: Array<ITodoLineItem & { showTooltip?: boolean }> = []
      items.forEach((item: Element, index: number) => {
        todos.push({
          ...this.todos[index],
          showTooltip: isEllipsisActive(item)
        })
      })

      this.todoModuleInstance.SET_TODOS(todos)
    })
  }
}
